import styled from 'styled-components';

export const AlertSpan = styled.span`
  color: ${({ theme }) => theme.colors.alert};
`;
